import React from 'react';
import { Link } from 'react-router-dom';

class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  }
    }
    render() { 
        return ( 
        <footer id="footer" style={{}}>
            <div className="empty-container"></div>
            <div className="kwizda-footer-container" >
                <div style={{display: 'inline-block'}}>Regisztrációjával kapcsolatos kérdés esetén írjon nekünk: 
                    <a className="footer-link" href="mailto:office@muchmore.hu">office@muchmore.hu</a></div>
                <div style={{float:'right', display: 'block'}}><Link className="footer-link" to="/szabalyzat">Részvételi feltételek és Adatkezelési tájékoztató</Link></div>
            </div>
        </footer> 
      );
    }
}
 
export default Footer;